import {
  PaginatedArticlesResponse,
  FetchArticlesParams,
  SearchArticlesParams,
} from "../types";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:5001";
const NEWS_API_KEY = process.env.REACT_APP_NEWS_API_KEY || "";

const buildHeaders = (): HeadersInit => {
  const headers: HeadersInit = {};
  if (NEWS_API_KEY) {
    headers["x-api-key"] = NEWS_API_KEY;
  }
  return headers;
};

export const fetchArticles = async (
  params: FetchArticlesParams = {}
): Promise<PaginatedArticlesResponse> => {
  const query = new URLSearchParams();

  if (params.category && params.category.toLowerCase() !== "all") {
    query.append("category", params.category);
  }
  if (params.source && params.source.toLowerCase() !== "all") {
    query.append("source", params.source);
  }
  if (params.from_date) {
    query.append("from_date", params.from_date);
  }
  if (params.to_date) {
    query.append("to_date", params.to_date);
  }
  if (params.page) {
    query.append("page", params.page.toString());
  }
  if (params.limit) {
    query.append("limit", params.limit.toString());
  }

  const response = await fetch(`${API_BASE_URL}/articles?${query.toString()}`, {
    headers: buildHeaders(),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch articles");
  }

  const data = await response.json();
  return data;
};

export const searchArticles = async (
  params: SearchArticlesParams
): Promise<PaginatedArticlesResponse> => {
  const query = new URLSearchParams();
  query.append("q", params.query);

  if (params.page) {
    query.append("page", params.page.toString());
  }
  if (params.limit) {
    query.append("limit", params.limit.toString());
  }

  const response = await fetch(`${API_BASE_URL}/search?${query.toString()}`, {
    headers: buildHeaders(),
  });

  if (!response.ok) {
    throw new Error("Failed to search articles");
  }

  const data = await response.json();
  return data;
};
